import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { IAuditTrailActionResponse } from "@/api_framework/api_modals/Inventory";
import { setAuditTrailAction } from "@/app_redux/reducers/slices/auth/inventory_slice";

AxiosCurlirize(axios, () => {});
export const useAuditTrailActionAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const execute = useCallback(async () => {
    try {
      await axios
        .get(INVENTORY_MODULE?.AUDIT_TRAIL_ACTION?.baseURL ?? "", {
          headers: {
            "x-audit-api-key": `Z74XW)a0dVszqE3d#=gUmR5=2f7gh5Kh#eQQXtuY&D%nRfeHyJXm_wtGyWdzzQx#(Z5b2`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IAuditTrailActionResponse>) => {
          if (res.data.status === true) {
            dispatch(setAuditTrailAction({ data: res.data.data }));
          } else {
            dispatch(setAuditTrailAction({ data: [] }));
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          captureError(e);
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
